import {
    CartSummaryLeftStyled,
    CartSummaryRightStyled,
    CartSummaryStyled,
    FreeTransportWrapperStyled,
    OpeningHoursStyled,
    TelephoneContactIconWrapperStyled,
    TelephoneContactStyled,
    TelephoneContactWrapperStyled,
} from './CartSummary.style';
import FreeTransportRange from 'components/Blocks/FreeTransportRange/FreeTransportRange';
import OrderAction from 'components/Blocks/OrderAction';
import PromoCode from 'components/Blocks/PromoCode';
import Button from 'components/Forms/Button/Button';
import Webline from 'components/Layout/Webline/Webline';
import CartPreview from 'components/Pages/Cart/CartPreview';
import { useCurrentCart } from 'connectors/cart/Cart';
import { useSettings } from 'connectors/Settings/Settings';
import { isB2bDomain } from 'helpers/isDomainLocale';
import { replaceAll } from 'helpers/replaceAll';
import { ActionEmptyCartHandler } from 'hooks/cart/useActionEmptyCart';
import { useTypedTranslationFunction } from 'hooks/typescript/UseTypedTranslationFunction';
import { useDomainConfig } from 'hooks/useDomainConfig';
import { PhoneIcon, SpinnerIcon } from 'public/svg/IconsSvg';
import { getInternationalizedStaticUrls } from 'utils/getInternationalizedStaticUrls';

type CartSummaryProps = {
    actionEmptyCart: ActionEmptyCartHandler;
    isActionEmptyCartFetching: boolean;
};

const CartSummary: FC<CartSummaryProps> = ({ isActionEmptyCartFetching, actionEmptyCart }) => {
    const t = useTypedTranslationFunction();
    const phone = t('Header phone number');
    const settings = useSettings();
    const { cart, isCartEmpty } = useCurrentCart();
    const totalPriceRemaining = cart?.remainingAmountForFreeTransport;
    const showFreeTransportRange =
        !isCartEmpty &&
        totalPriceRemaining !== null &&
        totalPriceRemaining !== undefined &&
        settings?.anyFreeTransportApplicableOnCondition === true;
    const domainConfig = useDomainConfig();
    const [transportAndPaymentUrl] = getInternationalizedStaticUrls(['/order/transport-and-payment'], domainConfig.url);
    const { diallingCode } = useDomainConfig();

    return (
        <Webline style={{ marginTop: '30px' }}>
            <CartSummaryStyled>
                <CartSummaryLeftStyled>
                    {!isB2bDomain(domainConfig) && <PromoCode />}
                    {isB2bDomain(domainConfig) && (
                        <div className="flex flex-col items-center vl:items-start">
                            <Button
                                isDisabled={isActionEmptyCartFetching}
                                onClick={() => actionEmptyCart('cart')}
                                className="mb-4 w-fit vl:mt-12 vl:mb-2"
                            >
                                {isActionEmptyCartFetching && <SpinnerIcon className="h-5 w-5" />}
                                {t('Empty the cart')}
                            </Button>
                        </div>
                    )}
                    {showFreeTransportRange && (
                        <FreeTransportWrapperStyled>
                            <FreeTransportRange isFullWidth />
                        </FreeTransportWrapperStyled>
                    )}
                    <TelephoneContactWrapperStyled>
                        {t('Order by phone')}
                        <TelephoneContactIconWrapperStyled>
                            <PhoneIcon />
                        </TelephoneContactIconWrapperStyled>
                        <TelephoneContactStyled href={`tel:${diallingCode}${replaceAll(phone, ' ', '')}`}>
                            {phone}
                        </TelephoneContactStyled>
                        <OpeningHoursStyled>{t('Header opening hours')}</OpeningHoursStyled>
                    </TelephoneContactWrapperStyled>
                </CartSummaryLeftStyled>
                <CartSummaryRightStyled>
                    <CartPreview />
                    <OrderAction
                        buttonText={t('Proceed to select shipping and payment')}
                        hasDisabledLook={false}
                        buttonLink={transportAndPaymentUrl}
                        isLastStep={false}
                    />
                </CartSummaryRightStyled>
            </CartSummaryStyled>
        </Webline>
    );
};

export default CartSummary;
